import { render, staticRenderFns } from "./ClientPluginUpdate.vue?vue&type=template&id=50bf4952&scoped=true&"
import script from "./ClientPluginUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientPluginUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ClientPluginUpdate.vue?vue&type=style&index=0&id=50bf4952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bf4952",
  null
  
)

export default component.exports